import Input from "components/EvtKit/input/Input"
import clsx from "clsx"
import Tooltip from "components/Tooltip"
import { memo } from "react"
import styled from "styled-components"

const FederatedKeyContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 48px;
  z-index: 1;
`
const ContainerInputButton = styled.div`
  width: 300px;
`

const RefreshIcon = styled.div`
  position: absolute;
  margin-top: 25px;
  padding-left: 400px;
  transform: translateY(-50%);
  z-index: 2;
  font-size: 20px;
  color: ${(props) => props.theme.palette.primary_one};
  cursor: pointer;
  user-select: none;

  &.disabled-icon {
    color: ${(props) => props.theme.palette.disabled};
  }
`

const IconContainer = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 110px;
  cursor: pointer;
`

interface Props {
  inputValue: string
  onClick: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  isDisabled?: boolean
}

const FederatedKeyInput = (props: Props) => {
  const { inputValue, onClick, onChange, isDisabled } = props

  return (
    <FederatedKeyContainer>
      <ContainerInputButton>
        <RefreshIcon
          onClick={isDisabled ? undefined : onClick}
          className={clsx({
            "disabled-icon": isDisabled
          })}
        >
          <IconContainer>
            <Tooltip text="Gerar Chave Automaticamente">&#x21bb;</Tooltip>
          </IconContainer>
        </RefreshIcon>
        <Input
          type="text"
          name="inputValue"
          label="Chave de integração com o Shelf *"
          value={inputValue}
          className="fullWidth"
          onChange={onChange}
          disabled={isDisabled}
          placeholder="Digite"
          shrink
          id="federatedKey"
        />
      </ContainerInputButton>
    </FederatedKeyContainer>
  )
}

export default memo(FederatedKeyInput)
